import { render, staticRenderFns } from "./ActionPlanPagination.vue?vue&type=template&id=0ecf2c8a&"
import script from "./ActionPlanPagination.vue?vue&type=script&lang=js&"
export * from "./ActionPlanPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports